module.exports = __webpack_public_path__ + "static/media/tech-support-icon.a8dcaecb.png";